import 'prop-types';
import { menuItemTapped } from '@dbh/menu';
import { TOP_MENU_DID_MOUNT } from '@dbh/top-menu';
import '@dbh/throw-in-server-side-rendering';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

const{type:menuItemTappedType}=menuItemTapped,topMenuDidMountType=TOP_MENU_DID_MOUNT;let lastMenuItemTappedEvent,topMenuMountedOnce=!1,eventDispatched=!1;withConformsTo("validateTypes",[],// eslint-disable-next-line no-unused-vars
()=>void 0);// This middleware delays processing of the menu item tapped event until
// the top menu has been mounted (lazy loaded).
const topMenuReduxMiddleware=a=>b=>c=>{// If we've already dispatched the stored event, just pass along the event.
if(eventDispatched)return b(c);const{type:d}=c||{};return d===menuItemTappedType&&(lastMenuItemTappedEvent=c),d!==topMenuDidMountType||topMenuMountedOnce||(topMenuMountedOnce=!0,lastMenuItemTappedEvent&&(a.dispatch(lastMenuItemTappedEvent),eventDispatched=!0)),b(c)};

export { topMenuReduxMiddleware as default };
